import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { AcceptUserInvite, CreateInvite, Invite, InviteListResponse, InviteQueryParams, InviteUsers, UpdateInvite } from '@frontend/user/types';

export class InviteClient extends APIClient {
    public static readonly endpoint = '/user-api/v1';

    public static async fetchInvites(queryParams?: ApiQueryParams<InviteQueryParams>): Promise<InviteListResponse> {
        return await this.apiPaginated<InviteListResponse, InviteQueryParams>(`${this.endpoint}/invites`, queryParams);
    }

    public static async resolveInvites(ids: string[], field: string = 'id'): Promise<InviteListResponse> {
        return this.resolve<InviteListResponse>(`${this.endpoint}/invites`, ids, field);
    }

    public static async deleteInvites(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/invites-delete`, { ids });
        return await this.handleVoidResponse(response);
    }

    public static async postInvite(accountId: string, invite: CreateInvite): Promise<Invite> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/invites`, invite);
        return await this.handleResponse<Invite>(response);
    }

    public static async fetchInvite(accountId: string, inviteId: string): Promise<Invite> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/invites/${inviteId}`);
        return await this.handleResponse<Invite>(response);
    }

    public static async patchInvite(accountId: string, inviteId: string, invite: Partial<UpdateInvite>): Promise<Invite> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/invites/${inviteId}`, invite);
        return await this.handleResponse<Invite>(response);
    }

    public static async deleteInvite(accountId: string, inviteId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/invites/${inviteId}`);
        return await this.handleVoidResponse(response);
    }

    public static async inviteUsers(accountId: string, body: InviteUsers): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/invite-users`, body);
        return await this.handleVoidResponse(response);
    }

    public static async acceptUserInvite(body: AcceptUserInvite, includeAccessToken = true): Promise<void> {
        const response = await this.post(`${this.endpoint}/accept-invite`, body, includeAccessToken);
        return await this.handleVoidResponse(response);
    }
}
